<template>
  <div class="customer-container default-table">
    <div class="head">
      <el-date-picker
          v-model="queryParams.year"
          value-format="yyyy"
          :clearable="false"
          format="yyyy年"
          size="mini"
          type="year"
          placeholder="选择年份" @change="handleSearch"/>
      <el-input @change="handleSearch" clearable style="width: 300px;margin:0 10px" v-model="queryParams.title"
                placeholder="模糊查询重点客户名称" size="mini"/>
      <!--      <CustomerRemoteSelect :model-value.sync="queryParams.title" class="customer"-->
      <!--                         @change="handleSearch"   clearable ref="CustomerRemoteSelect" :TypeSize="'mini'"/>-->
      <el-input @change="handleSearch" clearable style="width: 300px;margin:0 10px"
                v-model="queryParams.customer_sale_nm"
                placeholder="模糊查询销售名称" size="mini"/>
      <el-button type="primary" size="mini" @click="handleSearch" :loading="loading" :disabled="loading"
                 v-if="userAuth.key_customer_list">查询
      </el-button>
      <el-button type="primary" size="mini" @click="handleAppend" v-if="userAuth.key_customer_add">添加重点客户
      </el-button>
      <span class="tip-time" v-if="userAuth.key_customer_sync">
        <span v-if="updateDate">更新时间：{{ updateDate }} </span>
        <span v-else></span>
        <i style="display: inline-block;cursor: pointer;line-height: 50px" @click="handleRefresh('year')"
           title="数据更新" class="el-icon-refresh"></i>
      </span>
    </div>

    <MlPageTable
        :loading="loading"
        :all-columns='userColumns'
        :table-name='tableName'
        :data-list='tableData'
        :limit.sync='configPage.page_size'
        :page.sync='configPage.current_page'
        :total.sync='configPage.total'
        :show-index='false'
        height='650px'
        highlight-current-row
        @getList='getTableData'
        ref="elAdIncomeTable"
        stripe
        :border="true" v-if="userAuth.key_customer_list">
      <el-table-column slot="first-column" label="操作" header-align="center" width="220" align="center">
        <template slot-scope="{row}">
          <div class="flex-justify-se">
            <el-link type="primary" size="mini" icon="el-icon-edit"
                     :disabled="loading" @click="handleUpdate(row)" v-if="userAuth.key_customer_edit">修改
            </el-link>
            <el-link type="danger" size="mini" icon="el-icon-delete"
                     :disabled="loading" @click="handleDelete(row)" v-if="userAuth.key_customer_delete">删除
            </el-link>
            <el-link type="success" size="mini" icon="el-icon-s-data"
                     :disabled="loading" @click="handleDataScope(row)" v-if="userAuth.key_customer_scope">分配
            </el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          v-for="(item) in userColumns"
          :key="item.value"
          :prop="item.value"
          :label="item.title"
          header-align="center"
          align="center"
          :width="item.width"
          :slot="item.value"
          sortable>
        <template slot-scope="{row,column}">
          <template v-if="column.property==='title'">
            <el-link type="primary" @click="toDetail(row)">
              {{ row.title }}
            </el-link>
          </template>
          <template v-else-if="column.property==='finish_rate'">
            <el-link @click="handleInfoTable(row,column)">{{
                gFunc.numberFormat(row[column.property], 2) || 0
              }}%
            </el-link>
          </template>
          <template v-else>
            <el-link @click="handleInfoTable(row,column)">{{
                gFunc.numberFormat(row[column.property], 2) || 0
              }}
            </el-link>
          </template>
        </template>
      </el-table-column>
      <div slot="pageBefore" style="font-size: 14px;">
        年度总目标：<span style="font-size: 18px;font-weight: 550;font-family: FjallaOne-Regular, sans-serif !important">￥{{ amount|numberFormat(2)}}</span>
      </div>
    </MlPageTable>

    <!--    重点客户添加-->
    <key-account-modal :formStore.sync="formStore" :type="dialogType"
                       @success="successEdit" ref="keyAccountModal" :visible.sync="dialogStore"></key-account-modal>
    <!--重点客户关联订单-->
    <info-detail-modal @refresh="handleRefresh('month')" :visible.sync="detailModal"
                       ref="refInfoDetailModal" :search-condition="searchCondition"
                       v-if="searchCondition.id"></info-detail-modal>
    <!--     重点客户分配-->
    <DialogScope ref="refDialogScope"/>
  </div>
</template>

<script>
import {
  deleteProfileCustomer,
  getKeyCustomerAmount,
  getProfileCustomerList,
  RefreshProfileCustomer
} from "@/api/profileCustomer";
import MlPageTable from "@/components/MSettingColumn/MlPageTable.vue";
import KeyAccountModal from "@/views/custom/components/customer/key-account-modal.vue";
import InfoDetailModal from "@/views/custom/components/customer/info-detail-modal.vue";
import {gFunc} from "@/globalFunc";
import DialogScope from "@/views/custom/components/customer/DialogScope";

const ConfigPage = {
  layout: 'total, sizes, prev, pager, next, jumper',
  total: 0,
  page_size: 20,
  current_page: 1,
}
export default {
  name: "profileCustomer",
  components: {DialogScope, InfoDetailModal, KeyAccountModal, MlPageTable},
  data() {
    return {
      configPage: ConfigPage,
      loading: false,
      dialogStore: false,
      dialogType: 'add',
      queryParams: {title: null, year: null, customer_sale_nm: null},
      tableData: [],
      amount: 0,
      userColumns: [],
      prefixColumns: [{
          "hide": false,
          "title": "重点客户名称",
          "value": "title",
          "field": "title",
          "width": 200,
          "header_align": "center",
          "align": "center",
          "slot": true,
          "fixed": false,
          "sortable": false,
          "editable": false
        }, {
          "hide": false,
          "title": "年度目标",
          "value": "amount",
          "field": "amount",
          "width": 150,
          "header_align": "center",
          "align": "center",
          "slot": true,
          "fixed": false,
          "sortable": false,
          "editable": false
      }],
      suffixColumns: [{
        "hide": false,
        "title": "汇总",
        "value": "total_money",
        "field": "total_money",
        "width": 100,
        "header_align": "center",
        "align": "center",
        "slot": true,
        "fixed": false,
        "sortable": false,
        "editable": false
      }, {
        "hide": false,
        "title": "完成进度",
        "value": "finish_rate",
        "field": "finish_rate",
        "width": 100,
        "header_align": "center",
        "align": "center",
        "slot": true,
        "fixed": false,
        "sortable": false,
        "editable": false
      }],
      tableName: 'profileCustomer',
      formStore: {
        title: null,
        customer_id: null,
        year: '',
        target_at: '',
        amount: 0,
      },
      isEdit: false,
      updateDate: null,
      detailModal: false,
      searchCondition: {}
    }
  },
  computed: {
    gFunc() {
      return gFunc
    },
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  created() {
    this.defaultYear()
    this.setColumns()
  },
  mounted() {
    this.handleSearch()
  },
  methods: {
    setColumns() {
      let data = []
      for (let i = 1; i <= 12; i++) {
        let formattedNumber = i < 10 ? '0' + i : i.toString();
        let init = {
          "hide": false,
          "title": `${formattedNumber} 月`,
          "value": `month_${formattedNumber}`,
          "field": `month_${formattedNumber}`,
          "width": 'auto',
          "header_align": "center",
          "align": "center",
          "slot": true,
          "fixed": false,
          "sortable": false,
          "editable": false
        }
        data.push(init)
      }
      this.userColumns = [...this.prefixColumns, ...data, ...this.suffixColumns]
      this.$forceUpdate()
    },
    handleUpdate(row) {
      // 日期
      // const date = new Date()
      row.year = this.queryParams.year
      // row.target_at = row.year + '-' + ((date.getMonth() + 1) >= 10 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)) + '-01'
      row.target_at = row.year + '-01-01'
      this.formStore = {...row}
      this.dialogStore = true;
    },
    handleAppend() {
      // 日期
      // const date = new Date()
      // const target_at = this.queryParams.year + '-' + ((date.getMonth() + 1) >= 10 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)) + '-01'
      const target_at = this.queryParams.year + '-01-01'
      this.formStore = {year: this.queryParams.year, target_at: target_at}
      this.dialogStore = true
    },
    handleDelete(obj) {
      this.showModal({
        h: this,
        text: `确认删除【${obj.title}】吗？`,
        confirmText: "",
        cancelText: "",
        confirm: async () => {
          this.loading = true
          const response = await deleteProfileCustomer({id: obj.id})
          if (!response.success) {
            this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
            return;
          }
          this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
          await this.getTableData()
          this.loading = false
        }
      });
    },
    handleSearch() {
      this.configPage.current_page = 1
      this.getTableData()
    },
    getParams() {
      const params = this.handleSearchCondition()
      Object.assign(params, {
        page_size: this.configPage.page_size,
        current_page: this.configPage.current_page
      })

      return params
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.queryParams).forEach((key) => {
        if (this.queryParams[key]) {
          condition[key] = this.queryParams[key]
        }
      })

      return condition
    },
    getAmount: async function () {
      const {data} = await getKeyCustomerAmount(this.getParams())
      this.amount = data || 0
    },
    async getTableData() {
      this.loading = true
      const {data} = await getProfileCustomerList(this.getParams())
      this.tableData = data.list || []
      this.configPage = data.pages
      this.configPage.total = data.pages.total || 0
      await this.getAmount()
      this.loading = false
    },
    defaultYear() {
      let date = new Date();
      this.queryParams.year = date.getFullYear() + ''
    },
    async successEdit() {
      await this.getTableData()
      this.formStore = {}
      this.dialogStore = false
    },
    async handleRefresh(type) {
      let queryParams = {}
      switch (type) {
        case 'year':
          queryParams = {
            year: this.queryParams.year
          }
          break;
        case 'month':
          queryParams = {
            year: this.queryParams.year,
            month: this.searchCondition.month,
            id: this.searchCondition.id
          }
      }

      const {data} = await RefreshProfileCustomer(queryParams)
      if (data) {
        this.$message.success(data.msg)
        if (type === 'year') {
          // await this.$refs.infoDetailModal.getList()
          setTimeout(async () => {
            await this.getTableData()
          }, 1000)

        }

      }
    },
    handleInfoTable(row, column) {
      let month = column.property.replace('month_', '')
      if (Number(month)) {
        this.searchCondition = {
          title: row.title,
          month: month,
          id: row.id,
          year_month: `${this.queryParams.year}-${month}`
        }
        this.detailModal = true
        this.$nextTick(() => {
          if (this.$refs['refInfoDetailModal'])
            this.$refs['refInfoDetailModal'].init(this.searchCondition)
        })
      }
    },
    toDetail(row) {
      const {href} = this.$router.resolve({
        name: `homeCustomerDetail`,
        query: {
          customerName: row.title,
          year: this.queryParams.year,
          keyCustomerId: row.id
        }
      });
      window.open(href, "_blank");
    },
    //展示分配组件
    handleDataScope(row) {
      // alert(id)
      this.$refs['refDialogScope'].show(row)
    }
  }
}
</script>

<style lang="scss">
.customer-container {
  padding: 10px !important;

  .head {
    margin: 10px 0;
  }

  .customer {
    display: inline-block;
    margin: 10px;

    .el-select {
      width: 300px !important;
    }
  }

  .tip-time {

    > * {
      color: #8a8e99;
      font-size: 12px;
      margin-right: 10px;
      float: right;
      line-height: 48px;
    }

  }

}
</style>
